<template>
  <a href="#toc" class="wrapper">
    <i class="iconmoon-arrow-top"></i>
    <span class="text">Back to contents</span>
  </a>
</template>

<script>
export default {
  name: "app-back-to-contents"
};
</script>

<style scoped lang="scss">
@import "./../../../../assets/styles/vars";

.wrapper {
  display: block;
  text-align: right;
  padding: 20px 0;
}

.text {
  color: #fff;
  display: inline-block;
  margin-left: 10px;
  font-size: 18px;
  position: relative;

  &:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 2px;
    background: $mainRed;
    left: 0;
    bottom: -8px;
  }
}
</style>
